import { ApplicationConfig, ErrorHandler, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { apiEnvironmentInterceptor } from './shared/interceptors/api-environment.interceptor';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SlackErrorHandler } from './shared/services/slack-error-handler';

// Função para inicializar as traduções antes da aplicação iniciar
// Seguindo as melhores práticas: usar o TranslateHttpLoader nativo e apenas configurar o idioma padrão
export function appInitializerFactory(translate: TranslateService) {
  return () => {
    // Configurar idiomas disponíveis
    translate.addLangs(['pt', 'en', 'es']);
    translate.setDefaultLang('pt');
    
    // Usar o idioma padrão - o TranslateHttpLoader carregará automaticamente as traduções
    return translate.use('pt').toPromise();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    BsDatepickerModule.forRoot().providers!,
    provideAnimations(),
    provideHttpClient(
      // Ordem importa: o `apiEnvironmentInterceptor` reescreve a base URL antes
      // do `authInterceptor` anexar o Bearer, garantindo que o token seja
      // aplicado à URL definitiva.
      withInterceptors([apiEnvironmentInterceptor, authInterceptor])
    ),
    provideNgxMask(),
    // IMPORTANTE: provideTranslateHttpLoader deve vir ANTES de provideTranslateService
    provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json'
    }),
    provideTranslateService({
      fallbackLang: 'pt',
      defaultLanguage: 'pt',
      useDefaultLang: true
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: ErrorHandler, useClass: SlackErrorHandler }
  ],

};
